import { HttpCase } from "../Http";
export class RCreportAPI {
 
  public static  getmeterserialdetail(input: any){
    //alert("modemview");
    var obj = JSON.stringify(input);
 
    var url = "/getProfileReportsDetails";
    
   const token = localStorage.getItem("Token");
    const resultMethod = HttpCase.axios()
      .post(url, obj,{
        headers: {
            'Authorization': 'Bearer '+token,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;  
  }
  public static  getrefresh(input: any){
    
    var url = "/getAllProfileReportsDetails";
    
   const token = localStorage.getItem("Token");
    const resultMethod = HttpCase.axios()
      .get(url,{
        headers: {
            'Authorization': 'Bearer '+token,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*"
        }
      })
      .then(res => {
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;  
  }
}
